import { useEffect, useState, useCallback } from 'react';
import { t as translate, getLanguage, setLanguage as setLang } from '../i18n';

export const useI18n = () => {
  const [lang, setLangState] = useState(getLanguage());

  useEffect(() => {
    const onChange = () => setLangState(getLanguage());
    window.addEventListener('lh_language_change', onChange);
    return () => window.removeEventListener('lh_language_change', onChange);
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const t = useCallback((key) => translate(key), [lang]);

  return { t, lang, setLang };
};
